var _rect, _rect2, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewReady(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 219,
    viewBox: "0 0 348 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 198,
    width: 91.5374,
    height: 10.8737,
    fill: "url(#paint0_linear_2591_1286)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 26,
    width: 254,
    height: 183,
    rx: 4,
    fill: "white",
    stroke: "#DADCE0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101 26H178V50H101V26Z",
    fill: "#F2F2F2",
    stroke: "#DADCE0",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178 26H256V50H178V26Z",
    fill: "#F2F2F2",
    stroke: "#DADCE0",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 26H327C329.209 26 331 27.7909 331 30V50H256V26Z",
    fill: "#F2F2F2",
    stroke: "#DADCE0",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101 26L101 209L81 209C78.7909 209 77 207.209 77 205L77 30C77 27.7909 78.7909 26 81 26L101 26Z",
    fill: "#F2F2F2",
    stroke: "#DADCE0",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 111,
    y1: 71,
    x2: 320,
    y2: 71,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 111,
    y1: 95,
    x2: 320,
    y2: 95,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 111,
    y1: 119,
    x2: 320,
    y2: 119,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 111,
    y1: 143,
    x2: 320,
    y2: 143,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 111,
    y1: 167,
    x2: 320,
    y2: 167,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 111,
    y1: 191,
    x2: 320,
    y2: 191,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 178,
    y1: 56,
    x2: 178,
    y2: 202,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 256,
    y1: 56,
    x2: 256,
    y2: 202,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 78,
    width: 30,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 101,
    width: 52,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 125,
    width: 52,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 149,
    width: 52,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 173,
    width: 61,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 55,
    width: 53,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 78,
    width: 34,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 101,
    width: 59,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 125,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 149,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 173,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 55,
    width: 34,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 78,
    width: 34,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 101,
    width: 34,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 125,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 149,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 173,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 55,
    width: 34,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2591_1286",
    x1: 0,
    y1: 208.017,
    x2: 77.1092,
    y2: 208.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewReady);
export default __webpack_public_path__ + "static/media/preview_ready.4b3ea66790806091f23a025920b09706.svg";
export { ForwardRef as ReactComponent };